<template>
    <div v-loading.fullscreen="loading">
        <div class="header">
            <el-button size="large" type="primary" @click="$router.push({ name: 'ForumAdd' })">Qo'shish</el-button>
        </div>
        <el-table :data="tableData" class="table" border height="calc(100vh - 263px)">
            <!-- EXPAND COLUMN -->
            <el-table-column type="expand">
                <template #default="scope">
                    <div style="padding: 20px; background: #f5f7fa;">
                        <el-row :gutter="20">
                            <!-- IP ADDRESS -->
                            <el-col :span="8">
                                <div
                                    style="background: #fff; border-radius: 8px; padding: 15px; border: 1px solid #e4e7ed;">
                                    <h4
                                        style="margin-top: 0; color: #67C23A; border-bottom: 2px solid #67C23A; padding-bottom: 8px;">
                                        🌐 IP Address
                                    </h4>
                                    <pre
                                        style="margin: 0; max-height: 300px; overflow: auto; font-size: 12px; background: #f5f7fa; padding: 10px; border-radius: 4px;">{{ JSON.stringify(scope.row.ip_address, null, 2) }}</pre>
                                </div>
                            </el-col>
                            <!-- REQUEST BODY -->
                            <el-col :span="8">
                                <div
                                    style="background: #fff; border-radius: 8px; padding: 15px; border: 1px solid #e4e7ed;">
                                    <h4
                                        style="margin-top: 0; color: #409EFF; border-bottom: 2px solid #409EFF; padding-bottom: 8px;">
                                        📤 Request Body
                                    </h4>
                                    <pre
                                        style="margin: 0; max-height: 300px; overflow: auto; font-size: 12px; background: #f5f7fa; padding: 10px; border-radius: 4px;">{{ JSON.stringify(scope.row.request_body, null, 2) }}</pre>
                                </div>
                            </el-col>

                            <!-- RESPONSE BODY -->
                            <el-col :span="8">
                                <div
                                    style="background: #fff; border-radius: 8px; padding: 15px; border: 1px solid #e4e7ed;">
                                    <h4
                                        style="margin-top: 0; color: #67C23A; border-bottom: 2px solid #67C23A; padding-bottom: 8px;">
                                        📥 Response Body
                                    </h4>
                                    <pre
                                        style="margin: 0; max-height: 300px; overflow: auto; font-size: 12px; background: #f5f7fa; padding: 10px; border-radius: 4px;">{{ JSON.stringify(scope.row.response_body, null, 2) }}</pre>
                                </div>
                            </el-col>


                        </el-row>
                    </div>
                </template>
            </el-table-column>

            <el-table-column type="index" label="T/R" width="80" align="center" :index="indexMethod" />
            <el-table-column prop="id" label="ID" width="60" />
            <el-table-column prop="changed" label="Done" width="70" align="center">
                <template #default="scope">
                    <CheckedIcon v-if="scope.row.changed" />
                    <XMarkIcon v-else />
                </template>
            </el-table-column>
            <el-table-column prop="user_id" label="User ID" min-width="180" align="center" />
            <el-table-column prop="user_role" label="User role" width="100" align="center" />
            <el-table-column prop="user_agent" label="User agent" min-width="200" align="center" />
            <el-table-column prop="endpoint" label="Endpoint" min-width="180" align="center">
                <template #default="scope">
                    <span class="log_method">[{{ scope.row.method }}]</span>
                    <span>{{ scope.row.endpoint }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="date" label="Date" width="150" align="center">
                <template #default="scope">
                    {{ $moment(scope.row.createdAt).utcOffset('+05:00').format('DD.MM.YYYY HH:mm:ss [GMT]Z') }}
                </template>
            </el-table-column>
        </el-table>

        <el-row>
            <el-col :span="24">
                <div class="pagination-wrapper">
                    <span v-if="totalElements">Jami: {{ totalCount }}</span>
                    <el-pagination background layout="sizes, prev, pager, next" :total="totalCount"
                        v-model:page-size="limit" v-model:current-page="page" @size-change="handleSizeChange"
                        @current-change="handleCurrentChange" />
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { ElNotification } from "element-plus";
import XMarkIcon from "@/components/icon/XMarkIcon.vue";
import CheckedIcon from "@/components/icon/CheckedIcon.vue";
// muammo hal bo'lsin
export default {
    name: "LogLists",
    components: { XMarkIcon, CheckedIcon },

    computed: {
        currentPage() {
            return this.$route.query.page ? parseInt(this.$route.query.page, 10) : 1;
        },
    },

    data() {
        return {
            loading: false,
            tableData: [],
            totalCount: 0,
            limit: 20,
            page: 1,
        }
    },
    methods: {
        indexMethod(index) {
            return index + (this.page - 1) * this.limit + 1
        },
        handleSizeChange() {
            this.$router.replace({ query: { ...this.$route.query, size: this.limit, page: 1 } });
            this.page = 1;
            this.getLogLists()
        },
        handleCurrentChange() {
            this.$router.replace({ query: { ...this.$route.query, page: this.page } });
            this.getLogLists()
        },

        getLogLists() {
            this.loading = true;
            this.$http.get(`api/v1/chronology/action-logs`, {
                params: {
                    limit: this.limit,
                    offset: this.limit * (this.page - 1),
                }
            }).then(({ data }) => {
                this.tableData = data.logs
                this.totalCount = data.total
            }).catch(({ response }) => {
                ElNotification.error({ message: response.data.message || "Ma'lumot yuklashda xatolik sodir bo'ldi. Iltimos, qayta urinib ko'ring." })
            }).finally(() => {
                this.loading = false
            })
        },
    },


    mounted() {
        if (this.$route.query.size) {
            this.limit = parseInt(this.$route.query.size)
        }
        if (this.$route.query.page) {
            this.page = parseInt(this.$route.query.page)
        }
        this.getLogLists();
    }

}
</script>

<style scoped>
.header {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;
    gap: 10px;
    align-items: center;
}

:deep(.el-table .el-table__cell) {
    z-index: unset !important;
}

.pagination-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 5px;
    margin-bottom: 3px;
    height: 40px;
}

.pagination-wrapper>span {
    color: #0A194E;
    font-family: "Montserrat-Bold", sans-serif;
}

.log_method {
    margin-right: 5px;
}
</style>